import { BrandImageSchema } from "@redotech/redo-marketplace-common/brand-types";
import { marketplaceType } from "@redotech/redo-marketplace-common/catalog";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getMarketplaceVendorCounts = {
  name: "getMarketplaceVendorCounts" as const,
  input: z.object({ marketplaceType: createEnum(marketplaceType) }),
  output: z.object({
    vendorCounts: z.array(
      z.object({
        vendor: z.string(),
        image: BrandImageSchema.nullish(),
        category: z.string().optional(),
        count: z.number(),
      }),
    ),
  }),
};
